module.exports = __webpack_public_path__ + "img/carousel-item-2.074396cd.svg";